import { SESSIONS_KEY } from './constants';
import { formatDate, scoreEpic } from './scoring';
import { Epic, Session } from '../types';

/**
 * Load saved sessions from local storage
 */
export function loadSessions(): Session[] {
    try {
        const raw = localStorage.getItem(SESSIONS_KEY);
        if (!raw) return [];
        return JSON.parse(raw);
    } catch {
        return [];
    }
}

/**
 * Save sessions to local storage
 */
export function saveSessions(sessions: Session[]) {
    try {
        const trimmed = sessions.slice(-52);
        localStorage.setItem(SESSIONS_KEY, JSON.stringify(trimmed));
    } catch {
        // ignore
    }
}

/**
 * Create a new session snapshot
 */
export function createSession(epics: Epic[], userId: string, label = ""): Session {
    const enriched = epics.map((e) => scoreEpic(e));
    const laneCounts: Record<string, number> = { Now: 0, Next: 0, Later: 0, Unassigned: 0 };
    let totalScore = 0;

    enriched.forEach((e) => {
        const lane = e.lane || 'Unassigned';
        laneCounts[lane] = (laneCounts[lane] || 0) + 1;
        totalScore += e.wsjf || 0;
    });

    return {
        id: `session-${Date.now()}`,
        userId,
        name: label || `Session ${formatDate(new Date().toISOString())}`,
        epics: enriched,
        createdAt: new Date().toISOString(),
        metadata: {
            totalEpics: epics.length,
            laneCounts,
            avgScore: epics.length > 0 ? totalScore / epics.length : 0,
        },
    };
}
